<script>
import { VMoney } from 'v-money'
import { Percent } from '@constants/Masks'
import { getNumber } from '@utils/Format'

export default {
  directives: {
    money: VMoney,
  },
  props: {
    type: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: 'Valor',
    },
    range: {
      type: Object,
      default: () => {
        return { min: 0, max: 1 }
      },
    },
  },
  data() {
    return {
      maskPercent: Percent,
      rules: {
        range: (v) =>
          !this.range ||
          (getNumber(v) >= this.range.min * 100 &&
            getNumber(v) <= this.range.max * 100) ||
          `O valor deve ser entre ${this.range.min * 100} e ${this.range.max *
            100}`,
      },
    }
  },
  methods: {
    teste(v) {
      console.log(v)
    },
  },
}
</script>

<template>
  <div>
    <v-text-field
      v-if="type === 'float'"
      v-money="maskPercent"
      style="max-width: 140px;"
      class="ml-2"
      dense
      :rules="[rules.range]"
      :value="value"
      :label="title"
      @change="teste"
    >
    </v-text-field>
  </div>
</template>


